import {useBaseCommunity} from "../store";

export default function isStandardBaseCommunity() {
    const baseCommunity = useBaseCommunity();
    return baseCommunity.toLowerCase() !== "thedonald";
}